import { checkResetPasswordToken } from './checkResetPasswordToken';
import { fetchPartnerUsers } from './fetchPartnerUsers';
import { fetchUsers } from './fetchUsers';
import { getEqualOrBelowRoles } from './getEqualOrBelowRoles';
import { getHigherRoles } from './getHigherRoles';
import { getUsersWithForms } from './getUsersWithForms';
import { updateUserRoles } from './updateUserRoles';

export const userService = {
  checkResetPasswordToken,
  fetchUsers,
  getEqualOrBelowRoles,
  getHigherRoles,
  getUsersWithForms,
  fetchPartnerUsers,
  updateUserRoles,
};
